import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ChevronDown, ChevronUp, CheckCircle2, ArrowRight } from "lucide-react";
import { fmtMoney } from "./dashUtils";

const SEVERITY = {
  1: "bg-red-500/10 text-red-500 border-red-500/20",
  2: "bg-amber-500/10 text-amber-600 border-amber-500/20",
  3: "bg-blue-500/10 text-blue-500 border-blue-500/20",
};

const NeedsAttention = ({ items }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const list = items || [];
  if (list.length === 0) {
    return (
      <div className="rounded-xl border border-emerald-500/20 bg-emerald-500/5 px-4 py-2.5 flex items-center gap-2" data-testid="needs-attention-clear">
        <CheckCircle2 className="w-4 h-4 text-emerald-600" />
        <span className="text-sm text-emerald-700 dark:text-emerald-400">All clear — nothing needs your attention right now</span>
      </div>
    );
  }
  const visible = expanded ? list : list.slice(0, 6);
  return (
    <div className="rounded-xl border border-amber-500/25 bg-amber-500/[0.04] p-4" data-testid="needs-attention">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-semibold text-foreground font-['Manrope'] flex items-center gap-2">
          <AlertTriangle className="w-4 h-4 text-amber-500" /> Needs Attention
          <span className="text-[10px] font-medium px-1.5 py-0.5 rounded-full bg-amber-500/15 text-amber-600">{list.length}</span>
        </h2>
        {list.length > 6 && (
          <button onClick={() => setExpanded((v) => !v)} className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid="attention-toggle">
            {expanded ? <>Less <ChevronUp className="w-3 h-3" /></> : <>All {list.length} <ChevronDown className="w-3 h-3" /></>}
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-2">
        {visible.map((a) => (
          <button
            key={a.type}
            onClick={() => navigate(a.link)}
            className={`flex items-center justify-between gap-2 rounded-lg border px-3 py-2 text-left transition-colors hover:brightness-105 ${SEVERITY[a.severity] || SEVERITY[3]}`}
            data-testid={`attention-${a.type}`}
          >
            <div className="min-w-0">
              <p className="text-sm font-semibold">{a.count} <span className="font-medium">{a.label}</span></p>
              {a.amount ? <p className="text-[11px] opacity-80">{fmtMoney(a.amount)} outstanding</p> : null}
            </div>
            <ArrowRight className="w-3.5 h-3.5 shrink-0 opacity-60" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default NeedsAttention;
